import './index.scss';
import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PhoneSpan from '../../../../shared/PhoneSpan';
import MailSpan from '../../../../shared/MailSpan/MailSpan';
import { useProfile } from '../../../../../store/Auth/authHooks';
import {
  useGetLocation,
  usePropertyManagementFetchLocationById,
} from '../../../../../store/RoomManagement/resourceManagementHooks';

const Footer = () => {
  const history = useHistory();
  const profile = useProfile();
  const { t } = useTranslation();
  const location = useGetLocation();
  const fetchLocation = usePropertyManagementFetchLocationById();

  useEffect(() => {
    if (profile?.locationId!) {
      fetchLocation(profile?.locationId!).then();
    }
  }, [profile?.locationId!]);

  return (
    <div className="footer-app-container">
      <div className="footer-title">
        {t('ASHTROM_HOSPITALITY_FOOTER')} © {new Date().getFullYear()}{' '}
      </div>
      <div className="footer-email">
        <MailSpan
          mail={
            location?.support?.email
              ? location?.support?.email.split(',')[0]
              : ''
          }
          className={'footer-mail'}
        />
      </div>
      <div className="footer-phone">
        <PhoneSpan
          phone={location?.support?.phone}
          className={'rtl-mirror-footer-phone'}
          dir={'ltr'}
        />
      </div>
      <div className="footer-terms">
        <span
          className="footer-terms-link"
          onClick={() => {
            history.push('/privacy-policy');
          }}
        >
          {t('PRIVACY_POLICY_LABEL')}
        </span>
        <span> & </span>
        <span
          className="footer-terms-link"
          onClick={() => {
            history.push('/terms');
          }}
        >
          {t('TERMS_LABEL')}
        </span>
      </div>
    </div>
  );
};

export default Footer;
